module.exports = __webpack_public_path__ + "static/media/pei.008d94b0.png";